import { Navigate, useLocation } from 'react-router-dom';
import { resolvePanelHomePath } from '@/application/navigation/menuHouses';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

/**
 * `/reports` ya no es un hub. Mismo home que el logo (US-122): Resumen o primera casa.
 * Conserva `period` para que el chip no deje `/reports?period=` vacío.
 */
export function ReportsIndexRedirect() {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const home = resolvePanelHomePath(hasPermission);
  return <Navigate to={{ pathname: home, search: location.search }} replace />;
}
